<template>
  <g class='node node--internal'
    :transform="calcNodeTransform(node)"
  >
    <!-- circle for individual -->
    <template v-if="node.data.type.indexOf('individual') >= 0">
      <circle cx="0" cy="60" r="60"
        :fill="nodeFillColor"
        :stroke="nodeStrokeColor"
        stroke-width="2px"/>
      <foreignObject x="-50" y="20" width="100" height="80">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          :style="nodeTextStlye">
          {{node.data.name}}
        </div>
      </foreignObject>
    </template>
    <!-- rect for other types of companies -->
    <template v-else-if="node.data.type && node.data.type.indexOf('individual') < 0">
      <rect x="-100" y="0" width="200" height="120"
        :fill="nodeFillColor"
        :stroke="nodeStrokeColor"
        stroke-width="2px"/>
      <foreignObject x="-90" y="10" width="180" height="100">
        <div xmlns="http://www.w3.org/1999/xhtml"
          :style="nodeTextStlye">
            {{node.data.name}}
          </div>
      </foreignObject>
    </template>
    <!-- dashed circle if not specified -->
    <template v-else>
      <circle cx="0" cy="60" r="60"
        :fill="nodeFillColor"
        :stroke="nodeStrokeColor"
        stroke-width="2px"
        stroke-dasharray="5,5"/>
      <foreignObject x="-50" y="20" width="100" height="80">
        <div xmlns="http://www.w3.org/1999/xhtml"
          :style="nodeTextStlye">
          {{node.data.name}}
        </div>
      </foreignObject>
    </template>
    <!-- shares number -->
    <text dy="150px" dx="1em" font-size="20px">
      {{ sharesText }}
    </text>
  </g>
</template>

<script>

export default {
  name: 'DiagramNode',
  props: ['node'],
  data () {
    return {
      // eslint-disable-next-line
      nodeTextStlye: 'display: flex;\
        justify-content: center;\
        align-items: center;\
        width: 100%;\
        height: 100%;\
        font-size: 20px;\
        word-break: break-word;\
        text-align: center;\
        color: #2c3e50;',
      shareThreshold: this.$store.state.shareThreshold
    }
  },
  methods: {
    calcNodeTransform (node) {
      return `translate(${node.x},${-node.y})`
    }
  },
  computed: {
    sharesText () {
      const data = this.node.data
      if ((!data.sharesNumber && !data.sharesPercentage) ||
        data.sharesPercentage === null) return ''
      let template = `${data.sharesPercentage}%`
      if (data.sharesNumber &&
        Number(data.sharesNumber) !== Number(data.sharesPercentage)) {
        template = template + ` (${data.sharesNumber})`
      }
      return template
    },
    nodeFillColor () {
      return this.node.data.sharesPercentage >= this.shareThreshold
        ? 'white'
        : '#F1F3F5'
    },
    nodeStrokeColor () {
      const data = this.node.data
      if (data.type && data.type === 'individual_shareholder') {
        if (data.sharesPercentage >= this.shareThreshold) return '#E94F37'
        return '#CED4DA'
      }
      if (data.type && data.type.indexOf('individual') === -1) {
        if (data.sharesPercentage >= this.shareThreshold) return '#3F88C5'
        return '#CED4DA'
      }
      return 'black'
    }
  }
}
</script>

<style scoped>

</style>
